@if (withContext !== false) {
  <ngx-skeleton-loader
    class="sub-nav-skeleton"
    [count]="1"
    [theme]="{ height: '60px' }"
  ></ngx-skeleton-loader>
}

<ngx-skeleton-loader
  class="sub-nav-skeleton"
  [count]="7"
  [theme]="{
    'border-radius': '2px',
    height: '16px',
  }"
></ngx-skeleton-loader>
